class BillfoldService {
  constructor ($q, $http, ngAuthSettings) {
    this.$q = $q;
    this.$http = $http;
    this.ngAuthSettings = ngAuthSettings;
  }
  
  getBranchesByThirdId(thirdId) {
    return this.$q((resolve, reject) => {
      this.$http({
        method: 'GET',
        url: this.ngAuthSettings.apiServiceBaseUri + '/user/third-center-operating?thirdId=' + thirdId,
        cache : false
      }).then(function (response) {
        resolve(response.data);
      }, function (reason) {
        reject(reason);
      });
    });
  }

  getOrderState(documentNumber, branchCode, orderNumber, limit, page, orden_compra='') {
    return this.$q((resolve, reject) => {
      this.$http({
        method: 'GET',
        url: this.ngAuthSettings.apiServiceBaseUri2  + this.ngAuthSettings.config.paths.REPORTS.SYNC.ORDER.STATES+
        '?terceroId=' + documentNumber +
        '&sucursalCodigo=' + branchCode +
        '&limit=' + limit +
        '&page=' + page +
        '&pedidoId=' + orderNumber +
        '&ordenCompra=' + orden_compra,
        cache : false
      }).then(function (response) {
        resolve(response.data);
      }, function (reason) {
        reject(reason);
      });
    });
  }
  
  getOrderStates(documentNumber, branchCode, limit, page, orderObject = null) {
    return this.$q((resolve, reject) => { 

      var orderColumn = orderObject !== null ? ('&typeOrder=' + orderObject.orderColumn) : '';
      var orderOrientation = orderObject !== null ? ('&orderOrientation=' + orderObject.orderOrientation) : '';

      this.$http({
        method: 'GET',
        url: this.ngAuthSettings.apiServiceBaseUri2 + this.ngAuthSettings.config.paths.REPORTS.SYNC.ORDER.STATES +
        '?terceroId=' + documentNumber +
        '&sucursalCodigo=' + branchCode +
        '&limit=' + limit +
        '&page=' + page 
        + orderColumn
        + orderOrientation,
        cache : false
      }).then(function (response) {
        resolve(response.data);
      }, function (reason) {
        reject(reason);
      });
    });
  }
  
  getOrderStatesBranches(documentNumber, branchCodes, fecha_ini, fecha_fin, limit, page) {
    return this.$q((resolve, reject) => {
      this.$http({
        method: 'POST',
        url: this.ngAuthSettings.apiServiceBaseUri2 + this.ngAuthSettings.config.paths.REPORTS.SYNC.ORDER.STATES2,
        data : {
          'documentoTercero' : documentNumber,
          'branchCode' : branchCodes,
          'fecha_ini' : fecha_ini,
          'fecha_fin' : fecha_fin,
          'limit' : limit,
          'page' : page
        },
        cache : false
      }).then(function (response) {
        resolve(response.data);
      }, function (reason) {
        reject(reason);
      });
    });
  }

  getExportExcel(orders,nameClient){
    return this.$q((resolve, reject) => {
      this.$http({
        method: 'POST',
        url: this.ngAuthSettings.apiServiceBaseUri2 + this.ngAuthSettings.config.paths.REPORTS.SYNC.ORDER.EXPORTEXCEL,
        data : {
          'orders' : orders,
          'nameClient': nameClient
        },
        headers: {'Content-Type': 'application/x-www-form-urlencoded'},
        cache : false
      }).then(function (response) {
        resolve(response.data);
      }, function (reason) {
        reject(reason);
      });
    });
  }
}

BillfoldService.$inject = ['$q','$http', 'ngAuthSettings'];

export default BillfoldService;



/** WEBPACK FOOTER **
 ** ./www/components/reports/orders/orders.service.js
 **/